<template>
  <div id="app" class="loaded">
    <Header />
    <router-view />
    <Footer />
    <!-- 模态框 -->
    <div
      class="modal fade"
      tabindex="-1"
      id="DisclaimerModal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">
              <b> Announcement </b>
            </h6>
            <!-- <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button> -->
          </div>
          <div class="modal-body" v-html="HomeData.Anncouncement"></div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline btn-outline-primary"
              data-bs-dismiss="modal"
              @click="disclaimerchoice()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/views/Header/index.vue";
import Footer from "@/views/Footer/index.vue";

export default {
  name: "App",
  created() {
    this.$nextTick(function () {
      this._$.OriginalManuscriptJS();
      this._$.Scroll();
      this._$.Resize();
      this.GetHomePage();
      $(document).click(function () {
        $(".Search").find('.SearchUl').hide();
      });
      // localStorage.clear();
    });
  },
  data() {
    return {
      HomeData: [],
    };
  },
  watch: {
    $route: {
      handler: "routeCue",
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    routeCue: function (val, oldVal) {
      if (val.name == "Home") {
      }
    },
    // 获取数据
    GetHomePage: function () {
      $.ajax({
        type: "GET",
        url: process.env.VUE_APP_API + "GetHomePage",
        data: { lang: localStorage.getItem("Language") || 1 },
        dataType: "json",
        success: (res) => {
          if (res.status === "SUCCESS") {
            this.HomeData = res.data;
          }
        },
        error: function (error) {
          console.log(error);
        },
      });
    },
    disclaimerchoice: function () {
      localStorage.setItem("disclaimerchoice", new Date().getTime());
    },
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style>
.modal-backdrop {
  z-index: 1050; /* Bootstrap 默认值 */
}
.modal {
  z-index: 1055; /* Bootstrap 默认值 */
}
</style>
